import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button, Field, Input, Section } from "@redipos/ui";
import { operacionesApi } from "../api.js";

function errMsg(e: unknown, fallback = "Error") {
  return e instanceof Error ? e.message : fallback;
}

/**
 * Alta asistida de cliente — mismo camino que el signup público
 * (ver apps/api/src/routes/admin/operaciones.ts), disparado por el
 * equipo interno en vez del propio cliente (ej. venta por WhatsApp).
 */
export default function CreateTenantPage() {
  const navigate = useNavigate();
  const [organizationName, setOrganizationName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setSaving(true);
    try {
      const result = await operacionesApi.createTenant({
        organizationName: organizationName.trim(),
        email: email.trim().toLowerCase(),
        phone: phone.trim(),
      });
      navigate(`/clientes/${result.tenantId}`);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4 max-w-lg">
      <Link to="/clientes" className="inline-flex items-center gap-1 text-sm text-fg-subtle hover:text-fg-muted">
        <ArrowLeft className="w-4 h-4" />
        Clientes
      </Link>

      <Section title="Nuevo cliente" subtitle="Alta asistida — el cliente recibe un correo para verificar su cuenta.">
        <form onSubmit={submit} className="space-y-4">
          {err && (
            <p className="text-sm text-danger rounded-input border border-danger/40 bg-danger-soft px-3 py-2">
              {err}
            </p>
          )}
          <Field label="Nombre de la organización" required>
            <Input
              value={organizationName}
              onChange={(e) => setOrganizationName(e.target.value)}
              placeholder="Almacén Doña María"
              required
            />
          </Field>
          <Field label="Email" required>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="dueno@negocio.com"
              required
            />
          </Field>
          <Field label="Celular" required>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="09xx xxx xxx" required />
          </Field>
          <p className="text-xs text-fg-subtle">
            Se crea con el plan por defecto (trial). Podés cambiarlo después desde Finanzas → Facturación del cliente.
          </p>
          <Button type="submit" loading={saving} loadingLabel="Creando…" className="w-full">
            Crear cliente
          </Button>
        </form>
      </Section>
    </div>
  );
}
